// extracted by mini-css-extract-plugin
export var centeredContent = "t_bh";
export var heroWithTitle = "t_bd";
export var pageContent = "t_t";
export var starIcon = "t_bg";
export var subtitleContainer = "t_bf";
export var titleContainer = "t_7";